export default "__VITE_ASSET__C6XQ_9dm__"